import { Image } from 'react-native';

const LogoImage = ({ style }) => (
  <Image
    source={require('./logo.svg').default}
    resizeMode="cover"
    style={style}
  />
);

export { LogoImage };
